import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, pipe } from 'rxjs';
import { CommonService } from 'src/app/services/shared/common.service';
import { TokenHandlerService } from './token-handler.service';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, ActivatedRoute } from "@angular/router";
import { catchError, map, tap } from 'rxjs/operators';
import { LocalStorageService } from './local-storage.service';
import { AuthenticationService } from './authentication.service';
import { EnvService } from '../../shared/environment-service/env.service';
@Injectable({
  providedIn: 'root'
})
export class AppInterceptorService implements HttpInterceptor {
  constructor(private commonService: CommonService, private tokenhandler: TokenHandlerService, private router: Router,
    private activatedRoute: ActivatedRoute, private localStorageService: LocalStorageService, private auth: AuthenticationService,
    public env: EnvService) { }

  headerConfig = {};
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    const yourHeaderKeys = req.headers.keys();
    var use_main_db = "false"; // to be changed to fasle 
    var user = this.auth.getLoggedInUser();
    if (req.headers.has('use_main_db')) {
      use_main_db = req.headers.get('use_main_db');
    }

    if (req.url.includes('Attachment') || req.url.includes('Document')) {
      if (this.env.Keys.cloudManagerEnabled) {
        this.headerConfig = {
          'Authorization': `bearer ${this.auth.getToken()}`,
          'use_main_db': use_main_db,
          'company_id': user != null ? user.CompanyId.toString() : '-1',
          'token': this.auth.getToken()

        };
      }
      else {
        this.headerConfig = {
          'Authorization': `bearer ${this.auth.getToken()}`,
          'token': this.auth.getToken()

        };
      }
    }
    else {
      if (this.env.Keys.cloudManagerEnabled) {

        this.headerConfig = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Cache-Enabled': 'true',
          'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
          'Authorization': '',
          'use_main_db': use_main_db,
          'company_id': user != null ? user.CompanyId.toString() : '-1',
          'token': this.auth.getToken()
        };

      }
      else
        this.headerConfig = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Cache-Enabled': 'true',
          'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
          'Authorization': '',
          'use_main_db': 'true',
        };

      this.headerConfig['Authorization'] = `bearer ${this.auth.getToken()}`;
    }

 

    let a = this.localStorageService.encryptUsingAES256('lookupId=1');

 
    if (!req.url.includes('Attachment') && !req.url.includes('Document')) {
      let newUrlAfterReplaceArabicNumbers = this.toEnglishDigits(req.url);
      let body = req.body != null ? JSON.stringify(req.body) : null;
      let newBodyAfterReplaceArabicNumbers = this.toEnglishDigits(body);

      let jsonBody = JSON.parse(newBodyAfterReplaceArabicNumbers);

      req = req.clone({ url: newUrlAfterReplaceArabicNumbers });
      req = req.clone({ body: jsonBody });
    }

    const authReq = req.clone({ setHeaders: this.headerConfig });


    if (req != null)
      this.showLoader();

 

    return next.handle(authReq)
      .pipe(catchError((err) => {
        this.hideLoader();
        return err;
      }))
      .pipe(map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
        if (evt instanceof HttpResponse) {
          this.hideLoader();
        }
        return evt;
      }));

  }

  private showLoader(): void {     
    this.commonService.showOrHideSpinner(true);
  }

  private hideLoader(): void {
    this.commonService.showOrHideSpinner(false);    
  }


  toEnglishDigits(str) {
    if (str != null) {
      // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
      var e = '۰'.charCodeAt(0);
      str = str.replace(/[۰-۹]/g, function (t) {
        return t.charCodeAt(0) - e;
      });

      // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
      e = '٠'.charCodeAt(0);
      str = str.replace(/[٠-٩]/g, function (t) {
        return t.charCodeAt(0) - e;
      });
      return str;
    }
    return str;
  }

}
